// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1OHkO","header":"PatientQuestionnaire_header___4JCN","info":"PatientQuestionnaire_info__27b6S"};